<template>

  <div class="etx-container Container" :class="paragraphClassList">
    <div class="etx-center Center">

      <div class="etx-flex Flex tab-l:gv-0">

        <div class="etx-flex__item Flex__item tab-s:c-10 tab-m:c-9 tab-l:c-4 desk-s:c-3">

          <div class="etx-text Text" :class="entranceClassList">
            <h2 v-if="heading && headingType == 'h2'" class="font-h3 font-color-primary">{{ heading }}</h2>
            <h3 v-if="heading && headingType == 'h3'" class="font-h3 font-color-primary">{{ heading }}</h3>
            <h4 v-if="heading && headingType == 'h4'" class="font-h3 font-color-primary">{{ heading }}</h4>
            <p v-if="headingSubline" class="font-h3 alt">{{ headingSubline }}</p>
          </div>

        </div>

        <div class="etx-flex__item Flex__item tab-s:c-10 tab-m:c-9 tab-l:c-5 desk-s:c-6 tab-l:ml-1">

          <div class="etx-text Text" :class="entranceClassList">
            <p v-if="locationContactData?.address?.organization" class="font-lead">{{ locationContactData?.address?.organization }}
            </p>
            <p v-if="locationContactData?.address">
              {{ locationContactData?.address?.addressLine1 }}<br />
              {{ locationContactData?.address?.postalCode }} {{ locationContactData?.address?.locality }}, {{
                locationContactData?.address?.countryCode }}
            </p>
          </div>

          <div class="etx-item-list ItemList contact" :class="entranceClassList">

            <a v-if="locationContactData?.phone1" class="etx-item Item" :href="`tel:${ locationContactData.phone1 }`" title="">
              <div class="etx-item__icon Item__icon">
                <i class="fal fa-phone"></i>
              </div>
              <div class="etx-item__text Item__text">
                <span>{{ formatSwissPhoneNumber(locationContactData?.phone1) }}</span>
              </div>
            </a>

            <a v-if="locationContactData?.email1" class="etx-item Item" :href="`mailto:${ locationContactData.email1 }`" title="">
              <div class="etx-item__icon Item__icon">
                <i class="fal fa-envelope"></i>
              </div>
              <div class="etx-item__text Item__text">
                <span>{{ locationContactData?.email1 }}</span>
              </div>
            </a>

          </div>

          <div v-if="locationContactData?.openingHours" class="etx-spacer Spacer h-25 tab-l:h-50"></div>

          <LocationContactOpeningHours :openingHours="locationContactData.openingHours" :class="entranceClassList" />

        </div>

        <div class="etx-flex__item Flex__item tab-s:c-1 tab-m:c-2 tab-l:c-1 tab-s:ml-1 show-0 tab-s:show-1">

          <div class="BrandshapeWrapper falling-off-right desk-l:falling-off-max-right" :class="entranceClassList">

            <div class="Brandshape" :data-color-main="stripeColorMain" :data-color-accent="stripeColorAccent">
              <svg width="208" height="208">
                <use :xlink:href="stripeShape"></use>
              </svg>
            </div>

          </div>

        </div>

      </div>

    </div>
  </div>

</template>

<script lang="ts" setup>

const props = defineProps<{
  heading: string
  headingType: string
  headingSubline: string
  stripe: string
  parentId: string
}>()

const { options, isEditing } = defineBlokkli({
  bundle: 'location_contact_data',
  globalOptions: ['spacingTop', 'spacingBottom', 'backgroundColor'],
})

const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  if (options.value.backgroundColor !== 'white') {
    classList.push(options.value.backgroundColor)
  }

  return classList
})

const entranceClassList = computed(() => {
  const classList = []
  if (!isEditing) {
    classList.push('will-appear', 'move-up')
  }
  return classList
})

const stripeShape = computed(() => {
  return '#brandshape-' + props.stripe.split('_')[0]
})

const stripeColorMain = computed(() => {
  return props.stripe.split('_')[1]
})

const stripeColorAccent = computed(() => {
  return props.stripe.split('_')[2]
})

const currentNode: string = props.parentId ?? '0';
const queryKey = `getLocationContact-${currentNode}`;
const queryVars = {
  nid: [currentNode],
};

const { data: locationContactData } = await useAsyncData(queryKey, async () => {
  const result = await useGraphqlQuery('getLocation', queryVars);
  const items = result.data?.entityQuery?.items ?? [];

  return items.length > 0 ? {
    title: items[0].title,
    email1: items[0].email1,
    phone1: items[0].phone1,
    address: items[0].address,
    coordinates: items[0].coordinates,
    openingHours: items[0].openingHours,
  } : {};
});

</script>
